import React, { Component } from 'react';

class Header extends Component{
    render(){
       return (
       		<div>
	       		<header>
	          	<div className="logo" />
							<h3>I pledge allegiance to this lifestyle and who is real for which they stand, one culture under none, unstoppable, with real eyes to realize it all.</h3>
							<a className="btn" href="mailto:kylebebeau@gmail.com?subject=Product/Commission Inquiry">Email For Inquiries</a>
						</header>
          </div>
       );
    }
}

export default Header;
